import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, useTheme } from '@mui/material';
import React, { memo, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Header from '../../../components/Header';
import AddIcon from '@mui/icons-material/Add';
import { useDispatch, useSelector } from 'react-redux';
import { tokens } from '../../../theme';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { deleteStocktransfer, getStocktransfer } from '../../../redux/slice/Stocktransfer.slice';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import useMediaQuery from '@mui/material/useMediaQuery';

const StockTransferdata = memo(({ data, columns }) => {
    console.log("ddd",data);
    
    if (!data) {
        return <div style={{textAlign: 'center'}}>No data found</div>
    }

    if (!data || !Array.isArray(data)) {
        return <div>Loading...</div>;
    }

    return (
        <DataGrid
            rows={data}
            columns={columns}
            components={{ Toolbar: GridToolbar }}
            pageSize={5}
            rowsPerPageOptions={[5, 10]}
            density="compact"
            getRowId={(row) => row._id}
            autoHeight
            sx={{
                "@media print": {
                    "& .MuiDataGrid-toolbarContainer": {
                        display: "none !important"
                    },
                    "& .MuiDataGrid-root": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-cell": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-footerContainer": {
                        color: "black !important",
                    },
                    "& .css-7ms3qr-MuiTablePagination-displayedRows": {
                        color: "black !important",
                    },
                },
            }}
        />
    );
});


function StockTransfer() {

    const navigate = useNavigate();
    const theme = useTheme();
    const dispatch = useDispatch();
    const colors = tokens(theme.palette.mode);
    const [openView, setOpenView] = React.useState(false);
    const [viewData, setViewData] = useState(null);
    const [open, setOpen] = useState(false);
    const [update, setUpdate] = useState(null);
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [deleteStocktransferr, setDeleteStocktransferr] = useState(null);
    const isMobile = useMediaQuery('(max-width:500px)');


    const handleStockTransfer = () => {
        navigate('/admin/add-stock-transfer');
    };
    const stocktransfer = useSelector((state) => state.stocktransfer.stocktransfer.stocktransfer);
    useEffect(() => {
        dispatch(getStocktransfer());
    }, [])


    const handleClickOpenView = () => {
        setOpenView(true);
    };

    const handleCloseView = () => {
        setOpenView(false);
    };

    const handleView = (data) => {
        handleClickOpenView();
        setViewData(data)
    }


    const handleEdit = (data) => {
        const matchingStocktransfer = stocktransfer?.find(stocktransfers => stocktransfers.ProductName === data.ProductName);
        if (matchingStocktransfer) {
            setOpen(true);
            setUpdate(data);
            navigate('/admin/add-stock-transfer', { state: { _id: data._id } });
        } else {
            alert("Stock transfer not found.");
        }
    };

    const handleDelete = (id) => {
        setDeleteStocktransferr(id);
        setDeleteConfirmOpen(true);
    };

    const confirmDelete = () => {
        if (deleteStocktransferr) {
            dispatch(deleteStocktransfer(deleteStocktransferr));
            setDeleteConfirmOpen(false);
            setDeleteStocktransferr(null);
        }
    }
    const cancelDelete = () => {
        setDeleteConfirmOpen(false);
        setDeleteStocktransferr(null);
    }

    const columns = useMemo(() => [
        {
            field: 'categoryId',
            headerName: 'Category',
            width: 200,
            filterable: true,
            valueGetter: (params) => params.row.categoryData.map(detail =>
                detail?.categoryName || 'N/A'
            ).join(', '),
            renderCell: (params) => params.row.categoryData.map(detail =>
                detail?.categoryName || 'N/A'
            ).join(', ')
        },
        {
            field: 'subCategoryId',
            headerName: 'Sub Category',
            width: 200,
            filterable: true,
            valueGetter: (params) => params.row.subCategoryData.map(detail =>
                detail?.subCategoryName || 'N/A'
            ).join(', '),
            renderCell: (params) => params.row.subCategoryData.map(detail =>
                detail?.subCategoryName || 'N/A'
            ).join(', ')
        },
        {
            field: 'productId',
            headerName: 'Product Name',
            width: 250,
            filterable: true,
            valueGetter: (params) => params.row.productData.map(detail =>
                detail?.productName || 'N/A'
            ).join(', '),
            renderCell: (params) => params.row.productData.map(detail =>
                detail?.productName || 'N/A'
            ).join(', ')
        },
        {
            field: 'description',
            headerName: 'Description',
            width: 250,
            filterable: true
        },
        {
            field: 'unitofMeasurement',
            headerName: 'Unit of Measurement',
            width: 150,
            filterable: true
        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            width: 100,
            filterable: true
        },
        {
            field: 'debitWarehouseId',
            headerName: 'Debit Warehouse',
            width: 200,
            filterable: true,
            valueGetter: (params) => params.row.debitWarehouseData.map(detail =>
                detail?.wareHouseName || 'N/A'
            ).join(', '),
            renderCell: (params) => params.row.debitWarehouseData.map(detail =>
                detail?.wareHouseName || 'N/A'
            ).join(', ')
        },
        {
            field: 'creditWarehouseId',
            headerName: 'Credit Warehouse',
            width: 200,
            filterable: true,
            valueGetter: (params) => params.row.creditWarehouseData.map(detail =>
                detail?.wareHouseName || 'N/A'
            ).join(', '),
            renderCell: (params) => params.row.creditWarehouseData.map(detail =>
                detail?.wareHouseName || 'N/A'
            ).join(', ')
        },
        {
            field: 'pupose',
            headerName: 'Purpose',
            width: 100,
            filterable: true
        },
        {
            field: 'modeofTransport',
            headerName: 'Mode of Transport',
            width: 150,
            filterable: true
        },
        {
            field: 'Action',
            headerName: 'Action',
            width: 130,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <>
                    <IconButton
                        aria-label="view"
                        onClick={() => handleView(params.row)}
                    >
                        <RemoveRedEyeIcon />
                    </IconButton>
                    {/* <IconButton aria-label="delete"
                        onClick={() => handleDelete(params.row._id)}
                    >
                        <DeleteIcon />
                    </IconButton> */}
                </>
            )
        }
    ], []);


    return (
        <Box m="2px">
            <Header
                title="STOCK TRANSFER"
                subtitle="Manage Your Stock Transfer Here"
            />
            <Box display="flex" justifyContent="flex-end" mb={2}>
                <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleStockTransfer}>
                    Add Stock Transfer
                </Button>
            </Box>

            <Box
                height="75vh"
                sx={useMemo(() => ({
                    "& .MuiDataGrid-root": {
                        border: "none",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[700],
                        borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[700],
                    },
                    "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                        color: `${colors.grey[100]} !important`,
                        fontSize: "13px !important",
                    },
                }), [colors])}
            >
                <StockTransferdata data={stocktransfer} columns={columns} />
            </Box>

            <Dialog
                fullScreen={fullScreen}
                open={openView}
                onClose={handleCloseView}
                aria-labelledby="responsive-dialog-title"
                maxWidth={"sm"}
                fullWidth
            >
                <DialogTitle id="responsive-dialog-title" style={{ backgroundColor: theme.palette.background.purple, textAlign: "center", fontWeight: 'bold', fontSize: '18px' }}>
                    {"Stock Transfer Details"}
                </DialogTitle>
                <DialogContent style={{ backgroundColor: theme.palette.background.purple }}>
                    <DialogContentText>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2px' }}>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}>
                                <strong>Category : </strong> {viewData?.categoryData?.[0]?.categoryName || 'N/A'}
                            </p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}>
                                <strong>Sub Category: </strong> {viewData?.subCategoryData?.[0]?.subCategoryName || 'N/A'}
                            </p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}>
                                <strong>Product Name : </strong> {viewData?.productData?.[0]?.productName || 'N/A'}
                            </p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}>
                                <strong>Description : </strong> {viewData?.description}
                            </p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}>
                                <strong>Unit of Measurement : </strong> {viewData?.unitofMeasurement}
                            </p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}>
                                <strong>Quantity : </strong> {viewData?.quantity}
                            </p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}>
                                <strong>Debit Warehouse : </strong> {viewData?.debitWarehouseData?.[0]?.wareHouseName || 'N/A'}
                            </p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}>
                                <strong>Credit Warehouse : </strong> {viewData?.creditWarehouseData?.[0]?.wareHouseName || 'N/A'}
                            </p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}>
                                <strong>Purpose : </strong> {viewData?.pupose}
                            </p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}>
                                <strong>Mode of Transport : </strong> {viewData?.modeofTransport}
                            </p>
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ backgroundColor: theme.palette.background.purple }}>
                    <Button autoFocus onClick={handleCloseView} style={{ color: theme.palette.text.primary }}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={deleteConfirmOpen} onClose={cancelDelete}>
                <DialogContent>
                    Are you sure you want to delete this Stock Transfer Entry?
                </DialogContent>
                <DialogActions>
                    <Button onClick={cancelDelete} style={{ color: theme.palette.text.primary }}>No</Button>
                    <Button onClick={confirmDelete} style={{ color: theme.palette.text.primary }}>Yes</Button>
                </DialogActions>
            </Dialog>

        </Box >
    )
}

export default StockTransfer;
